import styled, { withTheme } from 'styled-components'

const SearchResults = styled.div`
  position: absolute;
  background-color: white;
  display: ${(props) => (props.hidden ? 'none' : 'auto')};
  border-top: 1px ${(props) => props.theme.colors.grey_light_op30} solid;
  top: 100%;
  left: 0;
  z-index: 1000;
  width: 100%;
  &::after {
    content: '';
    top: 0;
    left: 0;
    background-color: white;
    display: block;
    position: absolute;
    z-index: -1;
    width: 100%;
    height: 100%;
    box-shadow: 0 52px 52px 2px rgba(0, 0, 0, 0.35),
      0 20px 20px 0 rgba(0, 0, 0, 0.15);
  }
`

export default withTheme(SearchResults)
